import MainJumbo from '../components/MainJumbo';
import Gift from '../components/Gift';
import axios from 'axios';
import NoticeAndGallery from '../components/NoticeAndGallery';
import Course from '../components/CourseSummary';
import SideScroll from '../components/SideScroll';
import { useState, useEffect } from 'react';
import ReactPageScroller from 'react-page-scroller';

const Home = ({ history }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(true);

  // useEffect(() => {
  //   if (window.innerWidth <= 576) {
  //     setIsMobile(true);
  //   } else {
  //     setIsMobile(false);
  //   }
  // }, [window.innerWidth]);
  // const pageOnChange = (number) => {
  //   console.log('pageonChange: ' + number);
  //   setCurrentPage(number);
  // };

  const handleBeforePageScroll = (number) => {
    console.log('pagescroll:' + number);
    setCurrentPage(number);
  };
  if (!isMobile)
    return (
      <div>
        <SideScroll componentNum={3} currentPage={currentPage} />
        <ReactPageScroller
          // pageOnChange={pageOnChange}
          onBeforePageScroll={handleBeforePageScroll}
          customPageNumber={currentPage}
          renderAllPagesOnFirstRender={true}
        >
          <MainJumbo />
          <Course />
          <NoticeAndGallery history={history} />
        </ReactPageScroller>
      </div>
    );
  else {
    return (
      <div>
        <MainJumbo />
        <Course />
        <NoticeAndGallery history={history} />
      </div>
    );
  }
};
export default Home;
